import React, { useState, useEffect } from 'react';
import { GetUserById, updateUserDetails } from '../../Services/UserService';

function Profile() {
  const userId = localStorage.getItem("userId") ?? 9;

  const [userData, setUserData] = useState({
    name: '',
    email: '',
    password: '',
    dateOfBirth: '',
    phone: '',
    longitude: '',
    latitude: ''
  });

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUser();
  }, [userId]);

async function fetchUser() {
      setLoading(true);
      const response = await GetUserById(userId);
      if (response.status) {
        const data = response.data;
        setUserData({
          name: data.name || '',
          email: data.email || '',
          password: '',
          dateOfBirth: data.dateOfBirth ? data.dateOfBirth.split('T')[0] : '',
          phone: data.phone || '',
          longitude: data.longitude || '',
          latitude: data.latitude || ''
        });
        setError('');
      } else {
        setError(response.message || 'Failed to fetch user data');
      }
      setLoading(false);
    }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    const updatePayload = {
      name: userData.name,
      email: userData.email,
      password: userData.password,
      dateOfBirth: userData.dateOfBirth,
      phone: userData.phone,
      longitude: userData.longitude,
      latitude: userData.latitude
    };
    const response = await updateUserDetails(userId, updatePayload);
    if (response.status) {
      fetchUser();
      setMessage('User details updated successfully.');
      setError('');
    } else {
      setError(response.message || 'Failed to update user details.');
      setMessage('');
    }
  };

  if (loading) {
    return <div>Loading user data...</div>;
  }

  return (
    <div className="container mt-4">
  <div className="card shadow">
    <div className="card-header text-white">
      <h4 className="mb-0" style={{color:"#A37C4D"}}>Profile Details</h4>
    </div>
    
    <div className="card-body">
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        {/* Row start: Iske andar columns define honge */}
        <div className="row">
          
          {/* Name - Col 1 */}
          <div className="col-md-6 mb-3">
            <label htmlFor="name" className="form-label">Name</label>
            <input 
              type="text" 
              id="name"
              name="name"
              className="form-control"
              value={userData.name}
              onChange={handleChange}
              required 
            />
          </div>

          {/* Email - Col 2 */}
          <div className="col-md-6 mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input 
              type="email" 
              id="email"
              name="email"
              className="form-control"
              value={userData.email}
              onChange={handleChange}
              required 
            />
          </div>

          {/* Password - Col 1 */}
          <div className="col-md-6 mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input 
              type="password" 
              id="password"
              name="password"
              className="form-control"
              value={userData.password}
              onChange={handleChange}
            />
          </div>

          {/* Date of Birth - Col 2 */}
          <div className="col-md-6 mb-3">
            <label htmlFor="dateOfBirth" className="form-label">Date of Birth</label>
            <input 
              type="date" 
              id="dateOfBirth"
              name="dateOfBirth"
              className="form-control"
              value={userData.dateOfBirth}
              onChange={handleChange}
              required 
            />
          </div>

          {/* Phone - Col 1 */}
          <div className="col-md-6 mb-3">
            <label htmlFor="phone" className="form-label">Phone</label>
            <input 
              type="text" 
              id="phone"
              name="phone"
              className="form-control"
              value={userData.phone}
              onChange={handleChange}
              required 
            />
          </div>

           {/* Longitude - Col 2 */}
          <div className="col-md-6 mb-3">
            <label htmlFor="longitude" className="form-label">Longitude</label>
            <input 
              type="text" 
              id="longitude"
              name="longitude"
              className="form-control"
              value={userData.longitude}
              onChange={handleChange} 
            />
          </div>

          {/* Latitude - Col 1 (Next Row automatically) */}
          <div className="col-md-6 mb-3">
            <label htmlFor="latitude" className="form-label">Latitude</label>
            <input 
              type="text" 
              id="latitude"
              name="latitude"
              className="form-control"
              value={userData.latitude}
              onChange={handleChange} 
            />
          </div>

        </div> {/* Row End */}

        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
            <button type="submit" style={{backgroundColor:"#A37C4D",color:"white"}} className='btn'>Update Details</button>
        </div>
      </form>
    </div>
  </div>
</div>
  );
}

export default Profile;
